import { SocialLinks } from './SocialLinks';
import { Link } from 'react-router-dom';

/*
  Global footer for the non-designed (secondary) pages, styled to exactly match
  the Claude Design footer the flagship pages render inline — so the chrome is
  unified sitewide.
  NOTE: the previous footer contained a newsletter signup (POST /api/newsletter/subscribe).
  It was removed here to match the design footer. The logic is preserved in git
  history; re-add it as a dedicated section if lead capture is wanted.
*/

const linkStyle = { fontFamily: "'DM Sans',system-ui,sans-serif", fontWeight: 600, fontSize: 14, color: 'rgba(255,255,255,.85)', textDecoration: 'none' };
const legalStyle = { color: 'rgba(255,255,255,.5)', textDecoration: 'none' };

export const Footer = () => {
  const scrollTop = () => window.scrollTo({ top: 0, behavior: 'smooth' });
  return (
    <footer style={{ background: '#0a1721' }}>
      {/* 48px to match the navbar and every section; this was the other 24px gutter. */}
      <div style={{ maxWidth: 1240, margin: '0 auto', padding: '44px 48px', display: 'flex', alignItems: 'center', justifyContent: 'space-between', gap: 32, flexWrap: 'wrap' }}>
        <Link to="/" onClick={scrollTop}>
          <img src="/assets/logo-white.png" alt="The Home Library Project" style={{ height: 68, width: 'auto', display: 'block' }} />
        </Link>
        <div style={{ display: 'flex', flexDirection: 'column', alignItems: 'flex-end', gap: 14, textAlign: 'right' }}>
          <div style={{ display: 'flex', flexWrap: 'wrap', gap: 24, justifyContent: 'flex-end' }}>
            {[['Home', '/'], ['About', '/about'], ['Our Model', '/model'], ['Research', '/research'], ['Partner', '/partner'], ['Volunteer', '/volunteer'], ['Contact', '/contact'], ['Donate', '/donate']].map(([l, t]) => (
              <Link key={l} to={t} onClick={scrollTop} style={linkStyle}>{l}</Link>
            ))}
          </div>
          <SocialLinks />
          <div style={{ display: 'flex', alignItems: 'center', gap: 12, flexWrap: 'wrap', justifyContent: 'flex-end', color: 'rgba(255,255,255,.5)', fontFamily: "'DM Sans',system-ui,sans-serif", fontSize: 13, lineHeight: 1.5 }}>
            <span style={{ color: 'rgba(255,255,255,.55)' }}>&copy; {new Date().getFullYear()} The Home Library Project. 501(c)(3) Nonprofit Organization.</span>
            <Link to="/privacy" onClick={scrollTop} style={legalStyle}>Privacy Policy</Link>
            <span style={{ color: 'rgba(255,255,255,.35)' }}>&bull;</span>
            <Link to="/terms" onClick={scrollTop} style={legalStyle}>Terms of Service</Link>
          </div>
        </div>
      </div>
    </footer>
  );
};
